import ActionsQueue from './ActionsQueue'
import FirebaseClient from './FirebaseClient'
import NakamaClient from './NakamaClient'

import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

export const DATA_TYPE_ACTIONS_LIST = 'ACTIONS_LIST'
export const DATA_TYPE_ERROR = 'ERROR'
export const DATA_TYPE_REQUEST = 'REQUEST'

export const API_ERRORS = {
  SIGN_IN_ERROR: 'SIGN_IN_ERROR',
  MAKE_MATCH_ERROR: 'MAKE_MATCH_ERROR',
  JOIN_MATCH_ERROR: 'JOIN_MATCH_ERROR',
}

export default class Connector {
  constructor(
    firebaseConfig,
    nakamaConfig,
    clientVersion,
    protocolAdapterClass,
    actionHandlers
  ) {
    initializeApp(firebaseConfig)

    this._firebase = new FirebaseClient(clientVersion)
    this._nakama = new NakamaClient(nakamaConfig, protocolAdapterClass)
    this._queue = new ActionsQueue(actionHandlers)
    this._connected = false
    this._user = null
  }

  _onApiError(type, exception) {
    this._queue.fill([{ apiError: { type, exception } }])
  }

  disconnect() {
    this._connected = false
    this._queue.stop()
    this._firebase.disconnect()
    this._nakama.disconnect()
  }

  async init() {
    this._queue.start()
    const auth = getAuth()
    let reacted = false

    return new Promise((resolve, reject) => {
      onAuthStateChanged(auth, async (user) => {
        if (!reacted) {
          reacted = true
          this._user = user

          try {
            await this._firebase.signIn(user)
            this._connected = true
          } catch (e) {
            this._onApiError(API_ERRORS.SIGN_IN_ERROR, e)
          }

          resolve()
        }
      })

      this._nakama.onMatchData = (matchData) => {
        if (this._connected) {
          switch (matchData.type) {
            case DATA_TYPE_ACTIONS_LIST:
              this._queue.fill(matchData.data)
              break
            case DATA_TYPE_ERROR:
              this._queue.fill([{ protocolError: matchData.error }])
              break
            default:
              console.log('unsupported match data', matchData)
              break
          }
        }
      }
    })
  }

  async getRoomInfo(roomId) {
    return (await this._firebase.getRooms(roomId))[0].rooms[0]
  }

  async join(roomId, playerLevel = 1, tournamentId) {
    if (this._user && !this._user.isAnonymous) {
      try {
        const match = await this._firebase.makeMatch(roomId, tournamentId);

        try {
          return this._nakama.join(match, this._firebase.idToken)
        } catch (e) {
          // this._queue.fill([{nakamaError: e}]);
          this._onApiError(API_ERRORS.JOIN_MATCH_ERROR, e)
        }
      } catch (e) {
        this._onApiError(API_ERRORS.MAKE_MATCH_ERROR, e)
      }
    } else {
      return this._nakama.joinAnonymously(
        {
          room_id: roomId,
          player_level: playerLevel,
        },
        this._firebase.idToken
      )
    }

    return false
  }

  isAnonymous() {
    return this._firebase.isAnonymous()
  }

  confirmReady() {
    this._nakama.confirmReady()
  }

  async movePiece(move) {
    await this._queue.fill(move.actions())

    this._nakama.sendMove(move.id)
  }

  proposeDraw() {
    this._nakama.proposeDraw()
  }

  acceptDrawProposal() {
    this._nakama.acceptDrawProposal()
  }

  rejectDrawProposal() {
    this._nakama.rejectDrawProposal()
  }

  surrender() {
    this._nakama.surrender()
  }

  refreshUserSessionData() {
    if (this._user && !this._user.isAnonymous) {
      return fetch('/firebase/refresh', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: '{}',
      })
    }
  }
}
